import React from 'react';

export const BrandMark = ({ className = "w-8 h-8", glow = true }) => (
  <div className={`relative ${className} flex items-center justify-center`}>
    {/* Outer Hexagon Frame */}
    <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full text-cyan-500/20 fill-current">
      <path d="M50 5 L90 25 L90 75 L50 95 L10 75 L10 25 Z" />
    </svg>
    
    {/* Structural I-Beam & Light Ray */}
    <svg viewBox="0 0 100 100" className="relative z-10 w-full h-full">
      {/* Horizontal Beam */}
      <rect x="25" y="45" width="50" height="10" className="fill-cyan-400" rx="1" />
      <rect x="25" y="42" width="50" height="2" className="fill-cyan-300/50" />
      <rect x="25" y="56" width="50" height="2" className="fill-cyan-600/50" />
      
      {/* Vertical Support Hook */}
      <path d="M45 20 L55 20 L55 45 L45 45 Z" className="fill-slate-400" />
      
      {/* The "Beam" of Light */}
      <path 
        d="M50 45 L85 90 L15 90 Z" 
        className={`fill-cyan-500/30 ${glow ? 'animate-pulse' : ''}`}
        style={{ filter: 'blur(4px)' }}
      />
      
      {/* Safety Highlight */}
      <circle cx="50" cy="50" r="4" className="fill-yellow-500 shadow-lg" />
    </svg>
  </div>
);

export const BuildBeamLogo = ({ size = "md", showText = true }) => {
  const sizes = {
    sm: { mark: "w-6 h-6", text: "text-lg" },
    md: { mark: "w-8 h-8", text: "text-xl" },
    lg: { mark: "w-12 h-12", text: "text-3xl" }
  };

  return (
    <div className="flex items-center gap-3 group select-none">
      <BrandMark className={sizes[size].mark} />
      {showText && (
        <span className={`${sizes[size].text} font-bold tracking-[0.15em] text-slate-100 uppercase`}>
          Build<span className="text-cyan-400">Beam</span>
        </span>
      )}
    </div>
  );
};